export default __webpack_public_path__ + "static/media/logo-loterica-fundo-branco.a7fc23a8.jpg";